// Businesses used across War Room + capture classifier
export const BUSINESSES = [
  "PYN CAPITAL",
  "DOA / PRO PARTNER",
  "BIOVAULT",
  "PERSONAL",
  "OPERATOR OS",
];
